"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguage = exports.translateObject = exports.translateValue = exports.translateArray = void 0;
/* eslint-disable @typescript-eslint/no-use-before-define */
const lodash_1 = require("lodash");
const mapValues_1 = __importDefault(require("lodash/mapValues"));
function translateArray(array, language) {
    if (!array)
        return array;
    return array.map((obj) => translateValue(obj, language));
}
exports.translateArray = translateArray;
function translateValue(v, language) {
    if (!v)
        return v;
    if (Array.isArray(v)) {
        return translateArray(v, language);
    }
    if (typeof v === "object") {
        return translateObject(v, language);
    }
    return v;
}
exports.translateValue = translateValue;
function isEmptyValue(v) {
    return v === undefined || v === null || v === "";
}
function translateObject(object, language, keysToOmit) {
    if (!object)
        return object;
    const { translations = {} } = object, rest = __rest(object, ["translations"]);
    const translatedRest = (0, mapValues_1.default)(rest, (v, k) => {
        if (keysToOmit && keysToOmit.indexOf(k) !== -1)
            return v;
        return translateValue(v, language);
    });
    return Object.assign(Object.assign({}, translatedRest), (0, lodash_1.omitBy)(translations[language] || {}, isEmptyValue));
}
exports.translateObject = translateObject;
function getLanguage(object, lang) {
    if (!lang || !object)
        return {};
    if (lang in object)
        return object[lang];
    if (lang.indexOf("-") !== -1) {
        // Search for parent language (ex : FR-fr)
        const [parent] = lang.split("-");
        return object[parent] || {};
    }
    return {};
}
exports.getLanguage = getLanguage;
//# sourceMappingURL=translation.js.map